import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('api keys init')
}

export async function list(app, apiHost, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys?per_page=${
    constants.perPageCredentialListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let defaultErr = { message: 'Something went wrong. Please try refreshing the page' }
      if (error.response && error.response.data) defaultErr = error.response.data

      return defaultErr
    })
}

export async function get(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function add(post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function search(app, apiHost, searchText) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys?searchKey=${searchText}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function listByScope(app, apiHost, pageNo = 1, scope = 'authOnly') {
  const URL = `${getChatApiBase(app, apiHost)}/apikeys?per_page=${
    constants.perPageCredentialListings
  }&page=${pageNo}&scope=${scope}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let defaultErr = { message: 'Something went wrong. Please try refreshing the page' }
      if (error.response && error.response.data) defaultErr = error.response.data

      return defaultErr
    })
}
